import { render } from "./BaseCopyButton.vue?vue&type=template&id=3eb74b54&scoped=true"
import script from "./BaseCopyButton.vue?vue&type=script&lang=js"
export * from "./BaseCopyButton.vue?vue&type=script&lang=js"

import "./BaseCopyButton.vue?vue&type=style&index=0&id=3eb74b54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb74b54"]])

export default __exports__